module.exports = __webpack_public_path__ + "assets/img/teacher (41).077f86e9.png";